





import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import ResponsiveImage from 'frontend/components/ResponsiveImage.vue';
import { MAX_IMAGE_DENSITY, getBriocheImageSize, isBriocheImage } from 'frontend/utils/brioche';
import { appendGetParams } from 'frontend/utils/urls';

// array of strings, containing at least one element
interface SrcSet extends Array<string> {
  0: string;
}

interface ElementAttrsWidth {
  src: string | SrcSet;
  width: number;
}

interface ElementAttrsHeight {
  src: string | SrcSet;
  height: number;
}

type ElementAttrs = ElementAttrsWidth | ElementAttrsHeight;

@Component({
  components: {
    ResponsiveImage,
  },
})
export default class BriocheImageTag extends Vue {
  @Prop({ type: String, required: true }) readonly src!: string;
  @Prop({ type: String, required: true }) readonly alt!: string;
  @Prop(Number) readonly width!: number;
  @Prop(Number) readonly height!: number;

  get isBriocheImage(): boolean {
    return isBriocheImage(this.src);
  }

  private densitySrc(density: number): string {
    const { dimension, amount } = getBriocheImageSize(this.width, this.height);
    return appendGetParams(this.src, {
      [dimension]: amount * density,
    });
  }

  get currentDensitySrc(): string {
    const density = Math.round(Math.min(window.devicePixelRatio, MAX_IMAGE_DENSITY));
    return this.densitySrc(density);
  }

  private get briocheSrcSet(): SrcSet {
    return Array(MAX_IMAGE_DENSITY)
      .fill('')
      .map((_, i) => this.densitySrc(i + 1)) as SrcSet;
  }

  private get elementAttributes(): ElementAttrs {
    if (this.isBriocheImage) {
      if (this.width) {
        return {
          src: this.briocheSrcSet,
          width: this.width,
        };
      }
      return {
        src: this.briocheSrcSet,
        height: this.height,
      };
    }

    // non-brioche image
    if (this.width) {
      return {
        src: this.src,
        width: this.width,
      };
    }
    return {
      src: this.src,
      height: this.height,
    };
  }

  private created() {
    if (!this.width && !this.height) {
      throw new Error('BriocheImageTag requires either a "width" or a "height" prop');
    }
  }
}
